import { jsx as _jsx } from "react/jsx-runtime";
import StatTile from '../common/StatTile';
import { formatDate, formatRelativeDate } from '../../utils/date';
export default function NextRefillTile({ date, insufficientData }) {
    const hasDate = !insufficientData && !!date;
    return (_jsx(StatTile, { label: "Next Refill", value: hasDate ? formatDate(date) : 'Needs more history', caption: hasDate ? formatRelativeDate(date) : undefined }));
}
